/**
 * Shown when archiving a quote that is awaiting signature (READY_TO_SIGN):
 * archiving cancels the live signature request. Used by both single-quote
 * archive and the bulk archive confirmation.
 */
export const ARCHIVE_QUOTE_SIGNATURE_WARNING =
  'Any signature requests will be cancelled.'
